// SEO 元数据配置
const seoConfig = {
  zh: {
    title: 'Cross Gate: Adventure — 重温经典回合制宠物RPG',
    keywords: '魔力宝贝, Cross Gate, Cross Gate Adventure, 魔力宝贝手游, 宠物收集, 回合制, 养成RPG, mmo, 大型多人在线',
    description: 'Cross Gate: Adventure —— 收集、培养并指挥数百种经典魔宠，在怀旧回合制 MMO 中参与公会战、PVP 与史诗活动。'
  },
  tw: {
    title: '《魔力寶貝》Cross Gate — 經典回合制 × 寵物養成 MMORPG',
    keywords: '魔力寶貝, Cross Gate, 回合制 RPG, 寵物養成, 多人冒險, 法蘭城, MMORPG, 懷舊遊戲, 策略回合',
    description: '《魔力寶貝：重返法蘭》Cross Gate — 正版授權回合制 MMORPG 經典回歸！在法蘭城展開你的奇幻冒險，重溫最熟悉的回合策略。'
  },
  en: {
    title: 'Cross Gate: Adventure — Classic Turn-based Pet RPG',
    keywords: 'Cross Gate, Cross Gate Adventure, Cross Gate mobile, pet collection RPG, turn-based, monster collection, mobile RPG, mmo',
    description: 'Cross Gate: Adventure — Capture, train and battle hundreds of classic pets in a nostalgic turn-based MMO. Join guilds, PvP, and epic events on mobile.'
  },
  in: {
    title: 'Cross Gate: Adventure — RPG Peliharaan Turn-Based Klasik',
    keywords: 'Cross Gate, Cross Gate Adventure, Cross Gate mobile, RPG peliharaan, kumpulkan monster, turn-based, mobile RPG, mmo',
    description: 'Cross Gate: Adventure — Tangkap, latih, dan bertarung bersama ratusan monster ikonik dalam RPG turn-based MMO yang memadukan nostalgia dan gameplay modern.'
  },
  th: {
    title: 'Cross Gate: Adventure — RPG เทิร์นเบส สัตว์เลี้ยงคลาสสิก',
    keywords: 'Cross Gate, Cross Gate Adventure, เกมมือถือ Cross Gate, RPG สะสมสัตว์เลี้ยง, เทิร์นเบส, monster collection, mobile RPG, mmo',
    description: 'Cross Gate: Adventure — จับ ฝึก และต่อสู้กับสัตว์เลี้ยงคลาสสิกนับร้อยใน RPG เทิร์นเบส MMO เข้าร่วมกิลด์ PvP และกิจกรรมยิ่งใหญ่บนมือถือ'
  },
  fi: {
    title: 'Cross Gate: Adventure — Balikan ang Klasikong Turn-Based Pet RPG',
    keywords: 'Cross Gate, Cross Gate Adventure, Cross Gate mobile, turn-based RPG, pet collection, mobile RPG, monster collection, mmo',
    description: 'Cross Gate: Adventure — Manghuli, sanayin, at labanan ang daan-daang klasikong alagang-hayop sa isang turn-based MMO. Sumali sa guilds, PvP at malalaking events.'
  }
};

// 更新页面元数据
export function updatePageMeta(language) {
  const config = seoConfig[language] || seoConfig.zh;
  
  // 更新 title
  const titleElement = document.getElementById('page-title');
  if (titleElement) {
    titleElement.textContent = config.title;
  }
  document.title = config.title;
  
  // 更新 keywords
  const keywordsElement = document.getElementById('page-keywords');
  if (keywordsElement) {
    keywordsElement.setAttribute('content', config.keywords);
  }
  
  // 更新 description
  const descriptionElement = document.getElementById('page-description');
  if (descriptionElement) {
    descriptionElement.setAttribute('content', config.description);
  }
  
  // 更新 html lang 属性
  document.documentElement.setAttribute('lang', language);
  
  console.log(`页面元数据已更新为 ${language} 语言`);
}

// 获取当前语言的元数据配置
export function getCurrentMeta(language) {
  return seoConfig[language] || seoConfig.zh;
}

// 添加新的语言配置
export function addLanguageConfig(language, config) {
  seoConfig[language] = config;
}

export default {
  updatePageMeta,
  getCurrentMeta,
  addLanguageConfig,
  seoConfig
};